module.exports = __webpack_public_path__ + "static/how_it_works_banner-20b378a5d3ec627ee058c8407061f699.svg";